import { render, staticRenderFns } from "./AprovacaoGestor.vue?vue&type=template&id=18d92779&scoped=true"
import script from "./AprovacaoGestor.vue?vue&type=script&lang=js"
export * from "./AprovacaoGestor.vue?vue&type=script&lang=js"
import style0 from "./AprovacaoGestor.vue?vue&type=style&index=0&id=18d92779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d92779",
  null
  
)

export default component.exports